import React from "react";
import { OnClickButton } from '../Buttons'

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";
function tooltip(tooltip) {
  if (tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={tooltip}></i>
  else return null
}

export const FormDownloadFile = props => <>
  <label className="d-label">
    {tooltip(props.tooltip)}  <strong>{props.label}</strong>
  </label>
  <OnClickButton onClick={props.downloadFile} title={props.value} value={props.value} id={props.id} name={props.name} />
</>
